import React, {useEffect, useState} from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme} from "@material-ui/core/styles";
import Strings from "../lang/Strings";
import {Constants} from "../constants/Constants";
import {grey, red, yellow} from "@material-ui/core/colors";
import UsersManager from "../managers/UsersManager";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import QRCode from "qrcode.react";
import '../input.css';
import axios from "axios";
import EndPoints from "../net/EndPoints";
import RequestUtils from "../utils/RequestUtils";
import MaterialSnackBar from "../views/MaterialSnackBar";
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import ExceptionUtils from "../utils/ExceptionUtils";

// noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols,JSUnusedLocalSymbols,JSUnusedLocalSymbols
export default function BitcoinDepositDialog(props: any) {

    let open = props.open;
    const onDialogClosed = props.onDialogClosed;
    const [openDialog, setOpenDialog] = React.useState(open);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const loggedInUserString: string | undefined = useSelector((state: RootStateOrAny) => {
        let liveUserData = state.appReducer[Constants.LOGGED_IN_USER_DATA];
        if (!liveUserData) {
            liveUserData = UsersManager.getLoggedInUser() as string;
        }
        return liveUserData;
    });

    const loggedInUser = loggedInUserString ? JSON.parse(loggedInUserString) : undefined;

    const [errorEncountered, setErrorEncountered] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("success");
    const [generatingNewAddress, setGeneratingNewAddress] = useState(false);
    const addresses = loggedInUser["personalDepositAddresses"];
    const lastAddress = addresses[addresses.length - 1];
    const activeAddress = lastAddress !== undefined ? lastAddress["address"] : "";
    const activeQRCode = lastAddress !== undefined ? lastAddress["qrCode"] : "";

    const dispatch = useDispatch();

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const previouslyGeneratedAddressAvailable = () => {
        let userDepositAddresses = loggedInUser["personalDepositAddresses"]
        if (!userDepositAddresses) {
            return false
        }
        return userDepositAddresses.length > 1;
    }

    const areAddressesAvailable = () => {
        let userDepositAddresses = loggedInUser ? loggedInUser["personalDepositAddresses"] : JSON.parse(UsersManager.getLoggedInUser() as string)["personalDepositAddresses"];
        return userDepositAddresses.length > 0;
    }

    const handleDialogClose = () => {
        setOpenDialog(false);
        setErrorEncountered(false);
        onDialogClosed();
    }

    useEffect(() => {
        if (open) {
            if (!areAddressesAvailable()) {
                generateNewBitcoinAddress(false);
            }
        }
    }, [open]);

    const generateNewBitcoinAddress = (snack: boolean) => {
        if (snack) {
            setGeneratingNewAddress(true);
        }
        // noinspection JSUnusedLocalSymbols
        axios.get(EndPoints.GET_NEW_FUNDING_ADDRESS, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let responseData = response["data"]["data"]
            UsersManager.saveLoggedInUser(JSON.stringify(responseData));
            dispatch({
                type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                payload: JSON.stringify(responseData)
            })
            if (snack) {
                setSnackSeverity("success");
                setSnackMessage("New Address Generated");
                setOpenSnack(true);
            }
            setGeneratingNewAddress(false);
        }).catch(error => {
            let errorMessage = ExceptionUtils.getErrorMessage(error)
            if (previouslyGeneratedAddressAvailable()) {
                setGeneratingNewAddress(false);
                setSnackSeverity("error");
                setSnackMessage(errorMessage);
                setOpenSnack(true);
            }
            if (!previouslyGeneratedAddressAvailable()) {
                setErrorEncountered(true);
            }
        });
    }

    useEffect(() => {
        setOpenDialog(open);
    }, [open]);

    const buyBitcoins = () => {
        window.location.href = "https://localbitcoins.com"
    }

    // noinspection JSUnusedLocalSymbols
    const GeneratingFirstNewAddressView = React.forwardRef(function (props: any, ref: any) {
        return <DialogContent>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <CircularProgress/>
                <Typography>Please wait...</Typography>
            </div>
        </DialogContent>
    });

    // noinspection JSUnusedLocalSymbols
    const MainView = React.forwardRef(function (props: any, ref: any) {
        return <DialogContent>
            <Typography
                align={"center"}
                dangerouslySetInnerHTML={{__html: `You can send bitcoins to your personal deposit address and they will be credited to your ${Strings.APP_NAME} account after 1 <a href=${Constants.AFTER_ONE_CONFIRMATION_REF_LINK} style="text-decoration: none;text-underline: none">network confirmation</a>. We have no minimum deposit amount, we accept and credit all deposits to your account.`}}/>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginLeft: 10,
                marginRight: 10,
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderWidth: 1,
                    marginTop: 5
                }}>
                    <Typography align={"center"}
                                style={{
                                    background: `linear-gradient(to bottom,${yellow[700]} 5%,${yellow[800]} 100%)`,
                                    padding: 10,
                                    fontSize: 16,
                                    fontWeight: 600,
                                    borderRadius: '10px 10px 0 0',
                                }}>YOUR DEPOSIT ADDRESS</Typography>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            border: `1px solid ${grey[400]}`,
                            borderTopColor: yellow[400],
                        }}>
                        <input
                            contentEditable={false}
                            value={activeAddress}
                            style={{
                                borderColor: grey[100],
                                fontWeight: 600,
                                fontStyle: 'bold',
                                textAlign: 'center',
                                padding: 10,
                                color: 'black',
                                margin: 10
                            }}/>
                        <Typography style={{
                            fontSize: 13,
                            textAlign: 'center',
                            color: red[800]
                        }} dangerouslySetInnerHTML={{
                            __html: `Attention! This address can only receive <b>BITCOINS</b> and not any
                        other cryptocurrency`
                        }}/>
                        <QRCode
                            value={activeQRCode}
                            style={{
                                marginTop: 10,
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                marginBottom: 10,
                            }}/>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    marginTop: 10,
                    marginBottom: 10,
                    flexWrap: 'wrap'
                }}>
                    <Button variant={"contained"}
                            disabled={generatingNewAddress}
                            onClick={() => generateNewBitcoinAddress(true)}
                            style={{
                                marginRight: 10,
                                fontStyle: 'bold',
                                backgroundColor: yellow[700]
                            }}>New Deposit Address</Button>
                    <Button variant={"contained"}
                            onClick={buyBitcoins}
                            style={{
                                fontStyle: 'bold',
                                backgroundColor: yellow[700]
                            }}>Buy Bitcoins</Button>
                </div>
                <Typography align={"center"}>{`Please double-check that the address you have copied is correct before sending bitcoins from your
                    wallet since there are some malware that can change the deposit address after you copy it, resulting
                    in coins being sent to some other address and not your deposit address.
                    ${previouslyGeneratedAddressAvailable() ? previouslyGeneratedAddressesMsg : ""}`}
                </Typography>
                {
                    otherAddresses().length > 0 &&
                    <Accordion style={{
                        marginTop: 30,
                        marginLeft: 30,
                        marginRight: 30,
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{
                                background: yellow[700],
                            }}>
                            <Typography style={{
                                fontSize: 14,
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }} align={"center"}>OLD DEPOSIT ADDRESSES</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            {
                                otherAddresses().reverse().map((address: any) => {
                                    return <input
                                        contentEditable={false}
                                        value={address["address"]}
                                        style={{
                                            borderColor: grey[100],
                                            fontWeight: 600,
                                            fontStyle: 'bold',
                                            display: 'block',
                                            textAlign: 'center',
                                            padding: 10,
                                            color: 'black',
                                            margin: 10
                                        }}/>
                                })
                            }
                        </AccordionDetails>
                    </Accordion>
                }
            </div>
        </DialogContent>
    });

    // noinspection JSUnusedLocalSymbols
    const ErrorEncounteredView = React.forwardRef(function (props: any, ref: any) {
        return <DialogContent>
            <div>
                <Typography align={"center"}>Sorry, an error was encountered while generating a unique deposit address
                    for you.Please try again
                    after
                    1 hr. Thank you</Typography>
            </div>
        </DialogContent>
    });

    let tracked = false;
    const otherAddresses = () => {
        let personalAddressesClone = loggedInUser["personalDepositAddresses"];
        if (!tracked) {
            if (personalAddressesClone) {
                personalAddressesClone.splice(personalAddressesClone.length - 1, 1);
            }
            tracked = true;
        }
        return personalAddressesClone;
    }

    const previouslyGeneratedAddressesMsg = `Your previously generated bitcoin addresses are listed below. Any deposits sent to these addresses
        will also be credited to your ${Strings.APP_NAME} account after 1 confirmation`;

    return <Dialog disableBackdropClick={true}
                   fullScreen={fullScreen}
                   open={openDialog}
                   onClose={() => handleDialogClose()}
                   aria-labelledby="responsive-dialog-title">
        <DialogTitle style={{
            textAlign: 'center',
            fontWeight: 600,
            fontStyle: 'bold'
        }} id="responsive-dialog-title">{"DEPOSIT BITCOINS"}</DialogTitle>
        {
            areAddressesAvailable() && !errorEncountered &&
            <MainView/>
        }
        {
            !areAddressesAvailable() && !errorEncountered &&
            <GeneratingFirstNewAddressView/>
        }
        {
            errorEncountered &&
            <ErrorEncounteredView/>
        }
        <DialogActions>
            <Button autoFocus onClick={handleDialogClose} color="primary">
                CLOSE
            </Button>
        </DialogActions>
        <MaterialSnackBar
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            open={openSnack}
            onSnackClosed={handleSnackClose}
            message={snackMessage}
            severity={snackSeverity}/>
    </Dialog>
}